import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Headphones.svg",
  "use": "Headphones.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Headphones.svg\"><path d=\"M56.01,32.0208v12a4,4,0,0,1-4,4h-2v1a3,3,0,0,1-3,3h-2a3,3,0,0,1-3-3v-14a3,3,0,0,1,3-3h2a3,3,0,0,1,3,3v1h2v-4a20,20,0,0,0-40,0v4h2v-1a3,3,0,0,1,3-3h2a3,3,0,0,1,3,3v14a3,3,0,0,1-3,3h-2a3,3,0,0,1-3-3v-1h-2a4,4,0,0,1-4-4v-12a24,24,0,1,1,48,0Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol